<template>
  <div>
    <b-sidebar
      id="detail-issue-drawer"
      backdrop-variant="dark"
      backdrop
      right
      shadow
      width="700px"
      no-header
      :visible="visible"
      sidebar-class="right-drawer"
      aria-hidden="false"
      @hidden="onClose"
    >
      <div class="flex items-center justify-between border-b-[1px] border-[#F4F4F4] px-[24px] py-[20px]">
        <div class="flex items-center gap-[12px]">
          <feather-icon
            icon="XIcon"
            size="24"
            class="cursor-pointer text-[#828282] hover:text-black"
            @click="onClose"
          />
          <h4 class="font-bold text-black text-xl mb-0">
            Detail Issue
          </h4>
        </div>
      </div>

      <div
        v-if="issue"
        class="p-[24px] space-y-[20px]"
      >
        <div class="border-b-[1px] border-[#F4F4F4] pb-[20px]">
          <h5 class="text-[#333333] font-bold text-[15px] mb-[16px]">
            Partner Information
          </h5>
          <div class="space-y-[12px]">
            <div
              v-for="info in partnerInfoRows"
              :key="info.label"
              class="flex justify-between items-center text-[14px]"
            >
              <span class="text-[#828282]">{{ info.label }}</span>
              <span class="text-[#333333] font-semibold">{{ info.value }}</span>
            </div>
            <div class="flex justify-between items-center text-[14px]">
              <span class="text-[#828282]">Status</span>
              <b-dropdown
                v-if="issue.status === 'new_issue'"
                variant="outline-secondary"
                toggle-class="!flex items-center flex-nowrap gap-[6px] text-[#E12A2A] bg-white px-[12px] py-[6px] rounded-[6px]"
                no-caret
                right
              >
                <template #button-content>
                  <span class="k-warning-2 text-[16px] text-[#E12A2A]" />
                  <span class="text-[14px] font-semibold text-[#E12A2A]">New Issue</span>
                  <feather-icon
                    icon="ChevronDownIcon"
                    size="14"
                    class="ml-1"
                  />
                </template>
                <b-dropdown-item @click="$emit('move-on-process')">
                  Move to On Process
                </b-dropdown-item>
              </b-dropdown>
              <div
                v-else-if="issue.status === 'on_process'"
                class="text-[#FBA63C] rounded-sm border flex gap-1 items-center border-[1px] p-[3px]"
              >
                <span class="k-status text-[16px]" /><div class="text-[14px]">
                  On Process
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr>

        <div class="border-b-[1px] border-[#F4F4F4] pb-[20px]">
          <div class="flex justify-between items-center mb-[16px]">
            <h5 class="text-[#333333] font-bold text-[15px] mb-0">
              Balance
            </h5>
            <div
              class="flex items-center gap-[4px] bg-light px-[12px] py-[3px] rounded-[30px] text-[12px] font-bold"
              :class="isDiffBalanceDetected ? 'text-[#E12A2A]' : 'text-[#34A770]'"
            >
              <img
                :src="isDiffBalanceDetected ? 'https://storage.googleapis.com/komerce/icon/ie7/info-circle.svg' : 'https://storage.googleapis.com/komerce/komads-meta/tick-circle.svg'"
                alt="info"
              >
              <span>{{ isDiffBalanceDetected ? 'Detected' : 'Not Detected' }}</span>
            </div>
          </div>

          <div class="border-[1px] border-[#E2E2E2] rounded-[8px] p-[16px] space-y-[12px]">
            <div
              v-for="row in balanceRows"
              :key="row.label"
              class="flex justify-between items-center text-[14px]"
            >
              <span :class="row.labelClass">{{ row.label }}</span>
              <span :class="row.valueClass">{{ row.value }}</span>
            </div>
          </div>
        </div>
        <hr>

        <div class="border-b-[1px] border-[#F4F4F4] pb-[20px]">
          <div class="flex justify-between items-center mb-[16px]">
            <h5 class="text-[#333333] font-bold text-[15px] mb-0">
              Detail Missing Transaction
            </h5>
            <BButton
              :variant="hasMissingTransaction ? 'outline-primary' : 'outline-secondary'"
              class="px-[12px] py-[6px] rounded-[6px] font-semibold !flex items-center gap-[4px] bg-white flex-nowrap"
              :disabled="!hasMissingTransaction"
              @click="openListTransaction"
            >
              <span>List Transaction</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="14"
              />
            </BButton>
          </div>

          <div class="border-[1px] border-[#E2E2E2] rounded-[8px] p-[16px] space-y-[12px]">
            <div class="flex justify-between items-center text-[14px]">
              <span class="text-[#626262]">Missing Transaction</span>
              <span class="text-[#333333] font-medium">
                {{ missingTransactionCount || 0 }} Transaction
              </span>
            </div>
            <div class="flex justify-between items-center text-[14px]">
              <span class="text-[#626262]">Missing Amount</span>
              <span
                class="font-bold"
                :class="missingTransactionAmount === 0 ? 'text-[#34A770]' : 'text-[#E12A2A]'"
              >
                {{ formattedMissingAmount }}
              </span>
            </div>
          </div>
        </div>
        <hr>

        <div>
          <h5 class="text-[#333333] font-bold text-[15px] mb-[16px]">
            Activity
          </h5>
          <div class="border-[1px] border-[#E2E2E2] rounded-[8px] p-[16px]">
            <div class="flex justify-between items-center text-[14px]">
              <span class="text-[#626262] flex items-center gap-[8px]">
                <span class="text-[#828282]">•</span> Issue added
              </span>
              <span class="text-[#828282]">
                {{ formatActivityDate(activityDate) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import { IDR } from '@/libs/currency'
import moment from 'moment'

const MISSING_TRANSACTION_BASE_URL = '/komcards-dashboard/monitoring-check-balance-transaction/missing-transaction'

export default {
  name: 'DetailIssueDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    issue: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      infoBalance: null,
      missingTransactionCount: 0,
      missingTransactionAmount: 0,
      diffBalance: null,
    }
  },
  computed: {
    partnerInfoRows() {
      if (!this.issue) return []

      const { user, card } = this.issue
      return [
        { label: 'Full name', value: user?.name || '-' },
        { label: 'Email', value: user?.email || '-' },
        {
          label: 'Card name',
          value: card ? `${card.name} ****${card.last_number}` : '-',
        },
      ]
    },
    balanceRows() {
      if (!this.issue) return []

      const komcardBalance = this.infoBalance?.balance ?? this.issue.komcard_balance ?? 0
      const monitBalance = this.infoBalance?.real_balance ?? this.issue.monit_balance ?? 0
      const holdAmount = this.infoBalance?.hold_balance ?? this.issue.hold_amount ?? 0
      const balanceDiff = this.infoBalance?.diff_balance ?? ((this.issue.komcard_balance || 0) - (this.issue.monit_balance || 0))

      const baseLabelClass = 'text-[#626262]'
      const baseValueClass = 'text-[#333333] font-medium'

      return [
        {
          label: 'Komcards balance',
          value: this.formatCurrency(komcardBalance),
          labelClass: baseLabelClass,
          valueClass: baseValueClass,
        },
        {
          label: 'Monit balance',
          value: this.formatCurrency(monitBalance),
          labelClass: baseLabelClass,
          valueClass: baseValueClass,
        },
        {
          label: 'Hold amount',
          value: this.formatCurrency(holdAmount),
          labelClass: baseLabelClass,
          valueClass: baseValueClass,
        },
        {
          label: 'Balance difference',
          value: this.formatCurrency(balanceDiff),
          labelClass: 'text-[#333333] font-bold',
          valueClass: balanceDiff >= 0 ? 'text-[#34A770] font-bold' : 'text-[#E12A2A] font-bold',
        },
      ]
    },
    activityDate() {
      return this.issue?.history?.new_issue_at || this.issue?.date || null
    },
    hasMissingTransaction() {
      return this.missingTransactionCount !== 0
    },
    formattedMissingAmount() {
      return this.formatCurrency(this.missingTransactionAmount)
    },
    isDiffBalanceDetected() {
      return this.diffBalance !== 0
    },
  },
  watch: {
    visible(val) {
      if (val && this.issue) {
        this.getInfoBalance()
        this.getMissingTrx()
      } else if (!val) {
        this.infoBalance = null
        this.missingTransactionCount = 0
        this.missingTransactionAmount = 0
        this.diffBalance = null
      }
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    formatCurrency(amount) {
      const value = amount || 0
      return (value < 0 ? '-' : '') + IDR(Math.abs(value))
    },
    formatActivityDate(date) {
      return date ? moment(date).format('DD MMMM YYYY HH:mm:ss') : '-'
    },
    openListTransaction() {
      window.open(`${MISSING_TRANSACTION_BASE_URL}/${this.issue.card.id}`, '_blank')
    },
    async getInfoBalance() {
      try {
        const { data } = await newAxiosIns.get(`komcards/api/v1/card/${this.issue.card.id}/info-balance`)
        this.infoBalance = data?.data || null
        this.diffBalance = data?.data?.diff_balance ?? null
      } catch (err) {
        this.$toast_error({ message: err.response?.data?.message || 'Gagal mengambil data detail issue' })
      }
    },
    async getMissingTrx() {
      try {
        const { data } = await newAxiosIns.get(`komcards/api/v1/admin/ticket/${this.issue.id}/missing-transaction`)
        const responseData = data?.data
        this.missingTransactionCount = responseData?.total_missing || 0
        this.missingTransactionAmount = responseData?.total_amount_missing || 0
      } catch (err) {
        this.$toast_error({ message: err.response?.data?.message || 'Gagal mengambil data detail issue' })
      }
    },
  },
}
</script>
